// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCeO4XMT8q-6A-O1rLJeHePKcEH9Dtp-II",
  authDomain: "gj-bullion.firebaseapp.com",
  projectId: "gj-bullion",
  storageBucket: "gj-bullion.appspot.com",
  messagingSenderId: "841476349722",
  appId: "1:841476349722:web:fd7323726e870be10a96a3",
  measurementId: "G-E78T74GBKT",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let messaging = null;

export const getMessagingInstance = async () => {
  if (messaging) return messaging;
  try {
    const supported = await isSupported();
    if (supported && typeof window !== "undefined" && "serviceWorker" in navigator) {
      messaging = getMessaging(app);
      return messaging;
    }
  } catch (err) {
    console.warn("Firebase Messaging not supported in this environment:", err.message);
  }
  return null;
};

/**
 * Request permission and retrieve FCM Web Registration Token
 */
export const requestWebPushToken = async (vapidKey) => {
  const activeVapidKey = vapidKey || process.env.REACT_APP_FIREBASE_VAPID_KEY;
  try {
    if (typeof window === "undefined" || !("Notification" in window)) {
      throw new Error("This browser does not support desktop notifications.");
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return { success: false, reason: "permission_denied" };
    }

    const msg = await getMessagingInstance();
    if (!msg) {
      return { success: false, reason: "messaging_unsupported" };
    }

    // Register service worker if not already registered
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const currentToken = await getToken(msg, {
      serviceWorkerRegistration: registration,
      ...(activeVapidKey ? { vapidKey: activeVapidKey } : {}),
    });

    if (currentToken) {
      return { success: true, token: currentToken };
    } else {
      return { success: false, reason: "no_token_returned" };
    }
  } catch (err) {
    console.error("Error requesting Web Push token:", err);
    return { success: false, error: err.message };
  }
};

/**
 * Listen for foreground push messages
 */
export const onForegroundMessage = async (callback) => {
  const msg = await getMessagingInstance();
  if (!msg) return () => {};
  return onMessage(msg, (payload) => {
    console.log("Foreground notification received:", payload);
    callback(payload);
  });
};

export { app, auth };
